module.exports = __webpack_public_path__ + "static/media/Ordino-thumb.4cb54b3e.jpg";